export var VariantKey;
(function (VariantKey) {
    VariantKey["YELLOW"] = "YELLOW";
    VariantKey["RED"] = "RED";
    VariantKey["GREEN"] = "GREEN";
    VariantKey["NEW"] = "NEW";
    VariantKey["GREY"] = "GREY";
    VariantKey["BLUE"] = "BLUE";
})(VariantKey || (VariantKey = {}));
export const getBadgeStyle = (type, bmToken) => {
    switch (type) {
        case 'YELLOW':
            return {
                color: bmToken.BMUiBadgeInkYellow,
                backgroundColor: bmToken.BMUiBadgeBgcolorYellow,
            };
        case 'BLUE':
            return {
                color: bmToken.BMUiBadgeInkBlue,
                backgroundColor: bmToken.BMUiBadgeBgcolorBlue,
            };
        case 'RED':
            return {
                color: bmToken.BMUiBadgeInkRed,
                backgroundColor: bmToken.BMUiBadgeBgcolorRed,
            };
        case 'GREEN':
            return {
                color: bmToken.BMUiBadgeInkGreen,
                backgroundColor: bmToken.BMUiBadgeBgcolorGreen,
            };
        case 'GREY':
            return {
                color: bmToken.BMUiBadgeInkGrey,
                backgroundColor: bmToken.BMUiBadgeBgcolorGrey,
            };
        case 'NEW':
            return {
                color: bmToken.BMUiBadgeInkNew,
                backgroundColor: bmToken.BMUiBadgeBgcolorNew,
            };
        default:
            throw new Error(`Unknown BadgeTag type: ${type}`);
    }
};
